export default "__VITE_ASSET__DmaC1iia__"